import { useContext, useEffect, useRef, useState } from "react";
import { MqttContext } from "../../context/MQTTContext";

const SetDeviceInputsModal = ({
  setDeviceInputsModal,
  inputStates,
  device,
  type,
}) => {
  const { clients } = useContext(MqttContext);

  const [items, setItems] = useState(null);
  const [states, setStates] = useState(null);
  const [waiting, setWaiting] = useState(false);

  const modalName = useRef(0);
  const closeButton = useRef(0);

  useEffect(() => {
    setDeviceInputsModal(modalName);
  }, [setDeviceInputsModal]);

  // تابع برای دریافت وضعیت اولیه
  const fetchInitialData = () => {
    if (device && type == "input" && clients[device.id]) {
      setWaiting(true);
      
      let buffer = new ArrayBuffer(3);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 10;
      asciiCode[1] = 0;
      asciiCode[2] = 0;
      let message = device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.id].publish(device.serial + "/sys", combinedMessage);
    }
  };

  useEffect(() => {
    const messageListener = (topic, message) => {
      const endOfTwoCharToken =
        String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
      if (
        device?.internet_token?.slice(-2) === endOfTwoCharToken &&
        message[2] == 10
      ) {
        const newItems = message[4].toString(2).padStart(8, "0").split("").reverse().join("") +
          message[3].toString(2).padStart(8, "0").split("").reverse().join("");
        
        const newStates = message[6].toString(2).padStart(8, "0").split("").reverse().join("") +
          message[5].toString(2).padStart(8, "0").split("").reverse().join("");
        
        setItems(newItems);
        setStates(newStates);
        setWaiting(false);
      }
    };

    if (device && type == "input" && clients[device.id]) {
      clients[device.id].on("message", messageListener);
      
      // فقط در صورتی که اطلاعاتی نداریم، درخواست اولیه بفرست
      if (!items && !states) {
        fetchInitialData();
      }
    }

    // اضافه کردن event listener برای باز شدن مودال
    const handleShowModal = () => {
      if (device && type == "input" && clients[device.id]) {
        let buffer = new ArrayBuffer(3);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 10;
        asciiCode[1] = 0;
        asciiCode[2] = 0;
        let message = device.internet_token;
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    };

    modalName.current?.addEventListener("show.bs.modal", handleShowModal);

    return () => {
      if (device && clients[device.id]) {
        clients[device.id].off("message", messageListener);
      }
      modalName.current?.removeEventListener("show.bs.modal", handleShowModal);
    };
  }, [device, clients, type, items, states]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str);
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);
    newBuffer.set(encodedString, 0);
    newBuffer.set(new Uint8Array(buffer), encodedString.length);
    return newBuffer;
  };

  const handleChangeInput = (itemNum, stateNum) => {
    if (!clients[device.id]) return;
    setWaiting(true);
    
    let buffer = new ArrayBuffer(3);
    let asciiCode = new Uint8Array(buffer);
    asciiCode[0] = 10;
    asciiCode[1] = itemNum;
    asciiCode[2] = stateNum;
    let message = device.internet_token;
    let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
    clients[device.id].publish(device.serial + "/sys", combinedMessage);
  };

  // توابع کمکی برای دسترسی ایمن به مقادیر
  const getItemValue = (index) => {
    return items ? items[index] : '0';
  };

  const getStateValue = (index) => {
    return states ? states[index] : '0';
  };

  return (
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content" style={{
          boxShadow: waiting ? "0 0 0 7px rgba(13, 110, 253, 0.3), 0 0 15px 5px rgba(13, 110, 253, 0.2)" : "none",
          transition: "box-shadow 0.2s ease-in-out"
        }}>
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              تنظیم ورودی‌ها
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          
          <div className="modal-body">
            <div className="my-4">
              <div className="row my-3">
                <div className="col"></div>
                <div className="col">سناریو</div>
                <div className="col">حالت دائم</div>
              </div>
              
              {/* ورودی‌های 1 تا 16 */}
              {[...Array(12)].map((_, index) => (
                <div key={index} className="row py-3 rounded-3">
                  <div className="col">ورودی{index + 1}</div>
                  <div className="col">
                    <label className="switch switch-success-app w-auto">
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() =>
                          handleChangeInput(index + 1, getItemValue(index) === '0' ? 1 : 0)
                        }
                        checked={getItemValue(index) === '0'}
                      />
                      <span className="switch-toggle-slider">
                        <span className="switch-on"></span>
                        <span className="switch-off"></span>
                      </span>
                    </label>
                  </div>
                  <div className="col">
                    <label className="switch switch-success-app w-auto">
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() =>
                          handleChangeInput(index + 17, getStateValue(index) === '0' ? 1 : 0)
                        }
                        checked={getStateValue(index) === '0'}
                      />
                      <span className="switch-toggle-slider">
                        <span className="switch-on"></span>
                        <span className="switch-off"></span>
                      </span>
                    </label>
                  </div>
                </div>
              ))}
              
              <hr />
              
              {/* سناریوهای 1 تا 4 */}
              {[...Array(4)].map((_, index) => (
                <div key={index + 16} className="row py-3 rounded-3">
                  <div className="col">سناریو{index + 1}</div>
                  <div className="col">
                    <label className="switch switch-success-app w-auto">
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() =>
                          handleChangeInput(index + 13, getItemValue(index + 12) === '0' ? 1 : 0)
                        }
                        checked={getItemValue(index + 12) === '0'}
                      />
                      <span className="switch-toggle-slider">
                        <span className="switch-on"></span>
                        <span className="switch-off"></span>
                      </span>
                    </label>
                  </div>
                  <div className="col">
                    <label className="switch switch-success-app w-auto">
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() =>
                          handleChangeInput(index + 29, getStateValue(index + 12) === '0' ? 1 : 0)
                        }
                        checked={getStateValue(index + 12) === '0'}
                      />
                      <span className="switch-toggle-slider">
                        <span className="switch-on"></span>
                        <span className="switch-off"></span>
                      </span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetDeviceInputsModal;